import {
  AudioLines,
  BellIcon,
  Brain,
  LayoutDashboard,
  LogOut,
  Star,
  User,
} from "lucide-react";
import React, { useState } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { Nav } from "react-bootstrap";
import styles from "../../_css/Header.module.css";
import { deleteAuthToken } from "../../utils/helper";

const Header = () => {
  const [activeIcon, setActiveIcon] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const pathname = location.pathname;

  return (
    <Nav
      className={`${styles["header-nav"]} navbar justify-content-between d-flex`}
    >
      <NavLink style={{ width: "300px" }} to="/" className="nav-link">
        <i>
          <img
            src={`${process.env.REACT_APP_PROJECT_URL}/img/askSalah.png`}
            alt="logo"
            style={{ width: "4rem" }}
            // className={styles["header-logo"]}
          />
        </i>
      </NavLink>

      <NavLink
        onClick={(e) => {
          e.preventDefault();
          window.open("http://sal125.smartsway.com/", "_blank");
        }}
        className="nav-link"
      >
        <i>
          <img
            src={`${process.env.REACT_APP_PROJECT_URL}/img/sal125.png`}
            alt="logo"
            style={{ width: "7rem" }}
            // className={styles["header-logo"]}
          />
        </i>
      </NavLink>
      <div style={{ width: "300px" }} className="d-flex align-items-end">
        <ul
          style={{ listStyle: "none", color: "#6B7280" }}
          className="d-flex align-items-end gap-3 m-0"
        >
          <li>
            <i
              onClick={() => {
                deleteAuthToken();
                navigate("/login");
              }}
              className={`${styles["nav-icon"]} pe-cursor${
                pathname === "/logout" ? " " + styles["active"] : ""
              }`}
            >
              <LogOut size={18} />
            </i>
          </li>

          <li>
            <i
              onClick={() => navigate("/review-management")}
              // onClick={(e) => e.preventDefault()}
              className={`${styles["nav-icon"]} pe-cursor${
                pathname === "/review-management" ? " " + styles["active"] : ""
              }`}
            >
              <Star size={18} />
            </i>
          </li>
          <li>
            <i
              onClick={() => navigate("/session-category-management")}
              className={`${styles["nav-icon"]} pe-cursor border-icon${
                pathname === "/session-category-management"
                  ? " " + styles["active"]
                  : ""
              }`}
            >
              <AudioLines
                style={{
                  border: "1.5px solid",
                  borderRadius: "4px",
                }}
                size={18}
              />
            </i>
          </li>
          <li>
            <i
              onClick={() => navigate("/train-module")}
              className={`${styles["nav-icon"]} pe-cursor${
                pathname === "/train-module" ? " " + styles["active"] : ""
              }`}
            >
              <Brain size={18} />
            </i>
          </li>
          <li>
            <i
              onClick={() => navigate("/user-management")}
              className={`${styles["nav-icon"]} pe-cursor ${
                pathname === "/user-management" ? " " + styles["active"] : ""
              }`}
            >
              <User size={18} />
            </i>
          </li>
          <li>
            <i
              onClick={() => navigate("/")}
              className={`${styles["nav-icon"]} pe-cursor${
                pathname === "/" ? " " + styles["active"] : ""
              }`}
            >
              <LayoutDashboard size={18} />
            </i>
          </li>
        </ul>
      </div>
      {/* <div className="d-flex align-items-center gap-2">
        <UserCircle2Icon
          size={34}
          className="pe-cursor my-3 rounded-full"
        />
        <DropdownProfile userName = "Kamal Upadhyay" />
      </div> */}
      {/* {!isPendingUser && location.pathname.includes("offer-management") && (
        <NavLink
          to="/offer-management"
          className="nav-link"
          activeclassname={styles.active}
          onClick={(event) => event.preventDefault()}
        >
          <OverlayTrigger placement="right" overlay={tooltipOfferManagement}>
            <i>
              <Fan alt="Offer Management" className={styles.icon} />
            </i>
          </OverlayTrigger>
        </NavLink>
      )} */}
      {/* <NavLink
        to="/logout"
        className={`nav-link ${styles["bottom-0"]}`}
        onClick={(e) => e.preventDefault()}
        activeclassname={styles.active}
      >
        <SignOutButton />
        <img src={logoutIcon} alt="Logout" className={styles.icon} />
      </NavLink> */}
    </Nav>
  );
};

export default Header;
